import usePagination from "~/hooks/usePagination";
import useCurrentUser from "~/hooks/user/useCurrentUser";
import { whereToAnd } from "~/util/payload";

interface Params {
  role?: "tenant" | "owner";
}

/**
 * useGetPaginatedPermissions hook.
 *
 * This hook is used to get paginated permissions.
 */
const useGetPaginatedPermissions = ({ role = "owner" }: Params) => {
  const {
    data: { organization },
    isLoading: userLoading,
  } = useCurrentUser();

  const where: Record<string, any> = {
    organization: {
      equals: organization?.id,
    },
    roles: {
      equalsExact: role,
    },
  };

  return usePagination({
    collection: "organization-permissions",
    where: whereToAnd(where),
    serialLoading: userLoading,
    page: 1,
  });
};

export default useGetPaginatedPermissions;
